import * as z from "zod";

export const createSupportBaseSubscription = {
  name: "createSupportBaseSubscription" as const,
  input: z.object({}).optional(),
  output: z.object({
    success: z.boolean(),
    confirmationUrl: z.string().optional(),
  }),
};
